// productData.js
export const products = [
  {
    id: 12,
    slug: "bee-honey-soap-c9492219",
    name: "All Natural Bee Honey Soap",
    displayName: "Bee Honey Soap",
    isSale: true,
    salePercent: 20,
    price: 15.0,
    category: "body soap",
    mainCategories: "skincare",
    image: "/img/bee_honey_soap/all_natural_bee_honey_2.JPG",
    videoUrl: "/img/bee_honey_soap/all_natural_bee_honey.MP4",
    description:
      "Pure bee honey and propolis for moisturizing and antibacterial benefits",
    weight: 0.12,
    images: ["/img/bee_honey_soap/all_natural_bee_honey_2.JPG"],
    detailedDescription: `Crafted with raw bee honey and propolis, this nourishing soap delivers deep hydration while providing natural antibacterial protection. Honey's natural humectant properties help retain moisture, leaving skin supple, smooth, and beautifully conditioned.`,
    usage: `Usage Instructions:\n• Wet body and create rich lather\n• Massage over entire body\n• Rinse completely\n• For extra hydration, leave on skin for 1-2 minutes before rinsing\n• Use daily for soft, moisturized skin`,
    specifications: {
      keyIngredients: "Raw Bee Honey, Propolis, Beeswax, Oatmeal, Almond Oil",
      volume: "120g / 4.2oz",
      skinType: "Dry, sensitive, and normal skin",
      soapType: "Natural Honey-Infused Soap",
      texture: "Rich creamy lather, Golden amber bar",
      fragrance: "Warm, sweet honey aroma",
    },
    inStock: true,
    sku: "JMO-BSOAP-002",
    hasColors: false,
    reviews: [],
    likes: 0,
    benefits: [
      "Deeply moisturizes and hydrates skin",
      "Natural antibacterial properties",
      "Soothes and calms irritated skin",
      "Rich in antioxidants",
      "Promotes soft, supple skin",
    ],
    ingredients:
      "Mel (Honey), Propolis Extract, Cera Alba (Beeswax), Avena Sativa (Oat) Meal, Prunus Amygdalus Dulcis (Sweet Almond) Oil, Sodium Hydroxide, Aqua",
  },
  {
    id: 2,
    slug: "turmeric-body-butter-bf769986",
    name: "Glowing Turmeric Body Butter Cream",
    displayName: "Turmeric Body Butter",
    isBestSeller: true,
    isSale: true,
    salePrice: 25,
    price: 35,
    category: "Body Butter",
    mainCategories: "skincare",
    image: "/img/glowingTumeric/GlowingTumericBB.png",
    description:
      "Rich, nourishing body butter infused with turmeric to brighten, hydrate, and restore skin's natural glow.",
    weight: 0.3,
    images: [
      "/img/glowingTumeric/GlowingTumericBB.png",
      "/img/glowingTumeric/GlowingTumericBB2.png",
      "/img/glowingTumeric/GlowingTumericBB3_Human.png",
    ],
    detailedDescription: `This Glowing Turmeric Body Butter Cream is a luxurious blend crafted to deeply moisturize and rejuvenate your skin. Enriched with turmeric extract, it naturally brightens dull areas while providing powerful antioxidant protection. Shea butter and natural oils lock in hydration, leaving your skin smooth, radiant, and supple throughout the day.`,
    usage: `Application Instructions:\n• Apply generously to clean, dry skin after showering\n• Massage gently until fully absorbed\n• Focus on elbows, knees, and dry areas for best results\n• Use daily for optimal hydration and glow`,
    specifications: {
      keyIngredient: "Turmeric Extract",
      baseIngredients: "Shea Butter, Cocoa Butter, Coconut Oil",
      skinBenefits: "Brightening, Hydrating, Antioxidant-rich",
      texture: "Rich Cream",
      skinType: "Normal to Dry",
      volume: "200ml",
    },
    inStock: true,
    sku: "BC-BBTRM-003",
    hasColors: false,
    reviews: [],
    likes: 0,
    benefits: [
      "Natural brightening with turmeric",
      "Intense hydration",
      "Antioxidant protection",
      "Soothes and nourishes skin",
      "Long-lasting moisture",
    ],
    ingredients:
      "Turmeric Extract, Shea Butter, Cocoa Butter, Coconut Oil, Vitamin E",
  },
  {
    id: 3,
    slug: "everyday-scrubs-639636dd",
    name: "EveryDay Scrubs",
    displayName: false,
    price: 45,
    isSale: true,
    salePrice: 35,
    category: "scrubs",
    mainCategories: "scrub set",
    image: "/img/scrubs/test.png",
    description:
      "Professional medical scrubs designed for comfort during long shifts",
    weight: 0.2,
    hasColors: true,
    colors: [
      { name: "Blue", value: "blue", hex: "#4A90E2" },
      { name: "Grey", value: "grey", hex: "#8E8E93" },
      { name: "Powder Blue", value: "powder-blue", hex: "#B8D4F0" },
      { name: "Black", value: "black", hex: "#040303" },
    ],
    // Homepage card gallery uses the scrub hero plus the matching clinical-kit
    // support products shown in the provided references.
    images: [
      "/img/scrubs/test.png",
      "/img/medical_supplies/face_masks.png",
      "/img/medical_supplies/NitrileGloves.png",
      "/img/medical_supplies/dispoasable_sheets.png",
    ],
    detailedDescription: `Our Clinical Scrubs are engineered for healthcare professionals who demand both comfort and functionality. Made from premium stretch fabric with moisture-wicking technology, these scrubs keep you dry and comfortable during the longest shifts. The modern fit provides freedom of movement while maintaining a professional appearance.`,
    usage: `Care Instructions:\n• Machine wash cold with like colors\n• Tumble dry low\n• Do not bleach\n• Iron on low heat if needed\n• Avoid fabric softeners to maintain moisture-wicking properties`,
    specifications: {
      material: "Polyester-Cotton Blend with Stretch",
      availableColors: "Blue, Grey, Powder Blue, Black",
      sizes: "XS, S, M, L, XL, XXL",
      pockets: "2 chest pockets, 2 side pockets, 1 back pocket",
      closure: "Drawstring waist with adjustable tie",
      care: "Machine washable",
    },
    inStock: true,
    sku: "JMO-SCR-003",
    reviews: [],
    likes: 0,
    benefits: [
      "Moisture-wicking technology",
      "Stretch fabric for mobility",
      "Multiple utility pockets",
      "Professional fit",
      "Durable and long-lasting",
    ],
    ingredients: "",
  },
  {
    id: 1,
    slug: "vitamin-c-body-oil-79b8137b",
    name: "Vitamin C Glow Body Oil",
    displayName: "Vitamin C Body Oil",
    isBestSeller: true,
    price: 35,
    isSale: true,
    salePrice: 30,
    category: "Body Oil",
    mainCategories: "skincare",
    image: "/img/Vitamin_C_Glow_Body_Oil/Vitamin_C_GBO3.png",
    description:
      "Radiance-boosting body oil infused with Vitamin C and botanical oils to hydrate, brighten, and revive dull skin.",
    weight: 0.2,
    images: [
      "/img/Vitamin_C_Glow_Body_Oil/Vitamin_C_GBO2.png",
      "/img/Vitamin_C_Glow_Body_Oil/Vitamin_C_GBO4.png",
      "/img/Vitamin_C_Glow_Body_Oil/Vitamin_C_GBO.png",
      "/img/Vitamin_C_Glow_Body_Oil/Vitamin_C_GBO3.png",
    ],
    detailedDescription: `Experience radiant, healthy-looking skin with our Vitamin C Glow Body Oil. Formulated with a potent blend of Vitamin C and nourishing botanical oils, this lightweight body oil melts into skin to deliver deep hydration while helping to even out skin tone and restore natural glow. The fast-absorbing formula leaves a dewy finish without a greasy residue, making it perfect for daily use.`,
    usage: `How to Use:\n• Apply to damp or dry skin after showering or bathing\n• Massage in circular motions until fully absorbed\n• For best results, use daily morning and night\n• Can also be used as a bath oil or layered under lotion`,
    specifications: {
      keyIngredient: "Vitamin C (Ascorbic Acid)",
      skinBenefits: "Brightening, Hydrating, Smoothing",
      texture: "Lightweight, fast-absorbing oil",
      suitableFor: "All Skin Types",
      size: "200ml / 6.8 fl oz",
      dermatologistTested: "Yes",
    },
    inStock: true,
    sku: "JMO-BO-VC-001",
    hasColors: false,
    reviews: [],
    likes: 0,
    benefits: [
      "Brightens dull skin",
      "Deeply hydrates and nourishes",
      "Improves skin texture",
      "Restores natural glow",
      "Lightweight, fast-absorbing formula",
    ],
    ingredients:
      "Vitamin C, Coconut Oil, Jojoba Oil, Sweet Almond Oil, Rosehip Oil",
  },

  {
    id: 4,
    slug: "vitamin-c-glow-trio-set-0d4432d1",
    name: "Vitamin C Glow Trio Set",
    displayName: false,
    isSale: true,
    salePrice: 75,
    price: 90,
    category: "Body Cream",
    mainCategories: "skincare",
    image: "/img/trio_set/3set.png",
    description:
      "A luxurious 3-piece Vitamin C body care set featuring Body Oil, Brighten Body Butter, and Radiance Boosting Cream.",
    weight: 0.75,
    images: ["/img/trio_set/3set.png", "/img/trio_set/3set_human.png"],
    detailedDescription: `The Vitamin C Glow Trio Set brings together three essential body care products designed to nourish, brighten, and hydrate your skin. The set includes the Vitamin C Glow Body Oil, Vitamin C Brighten Body Butter, and Vitamin C Radiance Boosting Cream. Used together, these products deliver antioxidant protection while leaving your skin radiant, soft, and revitalized.`,
    usage: `Apply the Body Oil to damp skin after showering to lock in hydration. Massage the Brighten Body Butter into dry areas such as elbows and knees. Use the Radiance Boosting Cream daily as an all-over moisturizer.`,
    specifications: {
      setIncludes:
        "Body Oil (200ml), Brighten Body Butter (200ml), Radiance Boosting Cream (150ml)",
      keyIngredient: "Vitamin C Complex",
      skinBenefits: "Brightening, Hydrating, Smoothing",
      skinType: "All Skin Types",
      packaging: "Eco-friendly recyclable jars and pump bottle",
    },
    inStock: true,
    sku: "SET-VC-004",
    hasColors: false,
    reviews: [],
    likes: 0,
    benefits: [
      "Complete Vitamin C skincare routine",
      "Saves money compared to individual purchases",
      "Perfect for gifting",
      "Comprehensive skin nourishment",
      "Eco-friendly packaging",
    ],
    ingredients:
      "Vitamin C Complex, Botanical Oils, Shea Butter, Hyaluronic Acid",
  },
  {
    id: 5,
    slug: "vitamin-c-body-butter-a8282294",
    name: "Vitamin C Brighten Body Butter",
    displayName: "Vitamin C Body Butter",
    isNew: true,
    isSale: true,
    salePrice: 25,
    price: 30,
    category: "Body Butter",
    mainCategories: "skincare",
    image: "/img/Vitamin_C_Body_Butter/Vitamin_C_BBB.png",
    description:
      "A rich, nourishing body butter infused with Vitamin C to brighten, hydrate, and revitalize skin.",
    weight: 0.3,
    images: [
      "/img/Vitamin_C_Body_Butter/Vitamin_C_BBB.png",
      "/img/Vitamin_C_Body_Butter/Vitamin_C_BBB2.png",
      "/img/Vitamin_C_Body_Butter/Vitamin_C_BBB3.png",
    ],
    detailedDescription: `This Vitamin C Brighten Body Butter is a luxurious formula designed to deeply moisturize and restore your skin's natural glow. Infused with Vitamin C, it targets dullness, helps even skin tone, and protects against environmental stressors. Shea butter and natural oils provide long-lasting hydration.`,
    usage: `Application Instructions:\n• Apply generously to clean, dry skin after showering\n• Massage into skin until fully absorbed\n• Reapply to extra dry areas such as elbows, knees, and heels\n• Use daily for best results`,
    specifications: {
      keyIngredient: "Vitamin C Complex",
      baseIngredients: "Shea Butter, Cocoa Butter, Coconut Oil",
      skinBenefits: "Brightening, Hydrating, Revitalizing",
      texture: "Rich Cream",
      skinType: "Normal to Dry",
      volume: "200ml",
    },
    inStock: true,
    sku: "BC-VCBBB-005",
    hasColors: false,
    reviews: [],
    likes: 0,
    benefits: [
      "Intensive hydration",
      "Skin brightening",
      "Environmental protection",
      "Non-greasy absorption",
      "Suitable for sensitive skin",
    ],
    ingredients:
      "Vitamin C, Shea Butter, Cocoa Butter, Coconut Oil, Almond Oil",
  },
  {
    id: 6,
    slug: "turmeric-body-oil-c5b05f7d",
    name: "Glowing Turmeric Body Oil",
    displayName: "Turmeric Body Oil",
    isNew: true,
    isBestSeller: true,
    isSale: true,
    salePrice: 25,
    price: 35,
    category: "Body Oil",
    mainCategories: "skincare",
    image: "/img/GlowingTumeric_BO/GlowingTumericBO_Green_Leaves.png",
    description:
      "Radiance-boosting body oil infused with turmeric and botanical oils",
    weight: 0.25,
    images: [
      "/img/GlowingTumeric_BO/GlowingTumericBO.svg",
      "/img/GlowingTumeric_BO/GlowingTumericBO_Green_Leaves.png",
    ],
    detailedDescription: `Elevate your skincare routine with our Glowing Turmeric Body Oil, a luxurious blend of nourishing oils and antioxidant-rich turmeric extract. Designed to hydrate, brighten, and soothe the skin, this body oil melts effortlessly to deliver a dewy glow without greasiness.`,
    usage: `How to Use:\n• Apply to damp or dry skin and massage in circular motions\n• For best results, use daily after bathing\n• Can also be used as a bath oil or mixed with lotion\n• Suitable for all skin types`,
    specifications: {
      keyIngredients:
        "Turmeric Extract, Jojoba Oil, Sunflower Oil, Rosehip Oil",
      skinType: "All skin types",
      texture: "Lightweight, fast-absorbing oil",
      volume: "100ml / 3.4 fl oz",
      packaging: "Amber glass bottle with pump",
      scent: "Earthy with warm, herbal notes",
    },
    inStock: true,
    sku: "JMO-BODYOIL-006",
    hasColors: false,
    reviews: [],
    likes: 0,
    benefits: [
      "Instant radiance boost",
      "Deep hydration",
      "Antioxidant protection",
      "Lightweight formula",
      "Versatile usage",
    ],
    ingredients:
      "Turmeric Extract, Jojoba Oil, Sunflower Oil, Rosehip Oil, Essential Oils",
  },
  {
    id: 7,
    slug: "kojic-acid-soap-ddacf5e8",
    name: "Kojic Acid Soap",
    displayName: false,
    isSale: true,
    salePrice: 8,
    price: 15.0,
    category: "Body Soap",
    mainCategories: "skincare",
    image: "/img/Kojic_Acid/kojicAcid1.png",
    description: "Pure beauty soap for skin brightening",
    weight: 0.2,
    images: [
      "/img/Kojic_Acid/kojicAcid1.png",
      "/img/Kojic_Acid/kojic_acid.png",
    ],
    detailedDescription: `This premium Kojic Acid Soap is specially formulated to help brighten and even skin tone naturally. Kojic acid, derived from fermented rice, is known for its gentle yet effective skin-lightening properties. The soap creates a rich, creamy lather that cleanses deeply while being gentle on the skin.`,
    usage: `Application Instructions:\n• Wet skin with warm water\n• Work soap into a rich lather in your hands\n• Gently massage onto skin for 30-60 seconds\n• Rinse thoroughly with warm water\n• Use 1-2 times daily`,
    specifications: {
      keyIngredient: "Kojic Acid",
      weight: "135g / 4.76 oz",
      skinType: "All skin types",
      pHLevel: "6.5-7.0",
      texture: "Solid bar soap",
      fragrance: "Unscented",
    },
    inStock: true,
    sku: "JMO-SOAP-008",
    hasColors: false,
    reviews: [],
    likes: 0,
    benefits: [
      "Skin brightening",
      "Even skin tone",
      "Gentle exfoliation",
      "Reduces dark spots",
      "Natural formulation",
    ],
    ingredients: "Kojic Acid, Coconut Oil, Olive Oil, Palm Oil, Glycerin",
  },
  {
    id: 8,
    slug: "turmeric-face-soap-fd1553e9",
    name: "Turmeric Face Soap",
    displayName: false,
    price: 12,
    isSale: true,
    salePrice: 10,
    category: "Face Soap",
    mainCategories: "skincare",
    image: "/img/Tumeric_Soap/Tumeric_Face_Soap.png",
    description: "Natural turmeric soap for glowing, radiant skin",
    weight: 0.15,
    images: [
      "/img/Tumeric_Soap/Tumeric_face_soap_Human.png",
      "/img/Tumeric_Soap/Tumeric_Face_Soap.png",
      "/img/Tumeric_Soap/Tumeric_Face_Soap_2.png",
    ],
    detailedDescription: `This premium Turmeric Face Soap harnesses the natural power of turmeric to promote healthy, glowing skin. Turmeric has been used for centuries in traditional skincare for its anti-inflammatory and antioxidant properties. The gentle formula cleanses deeply while nourishing the skin.`,
    usage: `Application Instructions:\n• Wet face with lukewarm water\n• Gently rub soap between hands to create a rich lather\n• Massage onto face using circular motions for 30 seconds\n• Rinse thoroughly with cool water\n• Pat dry with a clean towel`,
    specifications: {
      keyIngredient: "Natural Turmeric",
      weight: "100g / 3.5 oz",
      skinType: "Acne-prone, Oily, Combination",
      pHLevel: "5.5-6.5 (Skin-friendly)",
      texture: "Solid bar, Orange-colored",
      fragrance: "Natural earthy scent",
    },
    inStock: true,
    sku: "JMO-SOAP-009",
    hasColors: false,
    reviews: [
      {
        id: 1,
        author: "Sarah Johnson",
        rating: 5,
        date: "2024-10-15",
        comment:
          "Absolutely love this soap! My acne has significantly reduced and my skin has a natural glow.",
        verified: true,
      },
      {
        id: 2,
        author: "David Martinez",
        rating: 4,
        date: "2024-10-08",
        comment:
          "Great for oily skin. Controls shine without drying out my face.",
        verified: true,
      },
      {
        id: 3,
        author: "Priya Sharma",
        rating: 5,
        date: "2024-09-30",
        comment:
          "Helped fade my acne scars noticeably. Gentle enough for daily use.",
        verified: true,
      },
    ],
    likes: 42,
    benefits: [
      "Reduces inflammation and redness",
      "Fights acne-causing bacteria",
      "Promotes even skin tone",
      "Natural antioxidant protection",
      "Gentle daily cleansing",
    ],
    ingredients:
      "Turmeric extract, Coconut oil, Olive oil, Shea butter, Essential oils",
  },
  {
    id: 9,
    slug: "12-herbs-hair-oil-1b476ad4",
    name: "12 Herbs Essential Oil Blend",
    displayName: "12 Herbs Hair Oil",
    price: 30,
    isSale: true,
    salePrice: 25,
    category: "hair oil",
    mainCategories: "haircare",
    image: "/img/HairOil/hairOil3.png",
    description:
      "100% Pure natural essential oil with 12 herbs blend for healthy hair & scalp",
    weight: 0.05,
    images: [
      "/img/HairOil/hairOil2.png",
      "/img/HairOil/hairOil.png",
      "/img/HairOil/hairOil3.png",
    ],
    detailedDescription: `This 100% Pure & Natural Essential Oil combines a powerful blend of 12 carefully selected herbs to promote optimal hair and scalp health. Formulated with traditional herbs known for their beneficial properties, this oil blend works to nourish, strengthen, and revitalize your hair from root to tip.`,
    usage: `Application Instructions:\n• Apply 5-10 drops to palm and massage directly into scalp\n• Focus on areas needing extra care\n• Leave on for 30 minutes to overnight\n• Shampoo and condition as usual\n• Use 2-3 times per week for best results`,
    specifications: {
      keyIngredients:
        "12 Herbs Blend (Rosemary, Horsetail, Nettle, Burdock Root, Hibiscus, Red Clover, Oat Straw, Calendula, Elderberry, Licorice Root, Dandelion Root, Marshmallow Root)",
      volume: "50ml / 1.69 fl.oz",
      hairType: "All hair types, especially dry, damaged, or thinning hair",
      oilType: "100% Pure Essential Oil Blend",
      texture: "Lightweight oil, Amber-colored",
      fragrance: "Natural herbal aroma",
    },
    inStock: true,
    sku: "JMO-HOIL-012",
    hasColors: false,
    reviews: [],
    likes: 0,
    benefits: [
      "Promotes hair growth and thickness",
      "Nourishes scalp and reduces dryness",
      "Strengthens hair follicles",
      "Reduces breakage and split ends",
      "Improves overall hair texture and shine",
    ],
    ingredients:
      "Rosemary Oil, Horsetail Extract, Nettle Oil, Burdock Root Oil, Hibiscus Extract, Red Clover Oil, Oat Straw Extract, Calendula Oil, Elderberry Extract, Licorice Root Oil, Dandelion Root Extract, Marshmallow Root Oil",
  },
  {
    id: 10,
    slug: "papaya-brightening-soap-44eff60a",
    name: "Papaya Vitamin C Brightening Soap",
    displayName: "Papaya Brightening Soap",
    price: 12,
    isSale: true,
    salePrice: 10,
    category: "facial soap",
    mainCategories: "skincare",
    image: "/img/papaya_vit_c/papaya_vit_C.JPG",
    videoUrl: "/img/papaya_vit_c/papaya_vit_C_Video.MP4",
    description:
      "Natural papaya extract with Vitamin C for brightening and even skin tone",
    weight: 0.1,
    images: ["/img/papaya_vit_c/papaya_vit_C.JPG"],
    detailedDescription: `This revitalizing soap combines the natural brightening power of papaya extract with potent Vitamin C to reveal brighter, more even-toned skin. Papaya enzymes gently exfoliate while Vitamin C fights dark spots and promotes collagen production for a radiant complexion.`,
    usage: `Usage Instructions:\n• Wet face and lather soap in hands\n• Gently massage onto face in circular motions\n• Rinse thoroughly with warm water\n• Pat dry and follow with moisturizer\n• Use daily for best results`,
    specifications: {
      keyIngredients:
        "Papaya Extract, Vitamin C, Coconut Oil, Olive Oil, Shea Butter",
      volume: "100g / 3.5oz",
      skinType: "All skin types, especially dull and uneven skin",
      soapType: "Natural Cold-Process Soap",
      texture: "Creamy lather, Orange-colored bar",
      fragrance: "Fresh tropical papaya scent",
    },
    inStock: true,
    sku: "JMO-FSOAP-001",
    hasColors: false,
    reviews: [],
    likes: 0,
    benefits: [
      "Brightens and evens skin tone",
      "Reduces appearance of dark spots",
      "Gently exfoliates dead skin cells",
      "Promotes collagen production",
      "Leaves skin soft and radiant",
    ],
    ingredients:
      "Papaya Extract, Ascorbic Acid (Vitamin C), Cocos Nucifera (Coconut) Oil, Olea Europaea (Olive) Fruit Oil, Butyrospermum Parkii (Shea) Butter, Sodium Hydroxide, Aqua",
  },
  {
    id: 11,
    slug: "white-now-brightening-soap-75eda6b1",
    name: "White Now Brightening Soap",
    displayName: false,
    isNew: true,
    price: 16,
    isSale: true,
    salePrice: 12,
    category: "facial soap",
    mainCategories: "skincare",
    image: "/img/white_now/white_now_with_soap.JPG",
    description:
      "Advanced brightening formula with glutathione and kojic acid for radiant skin",
    weight: 0.09,
    images: [
      "/img/white_now/white_Now.JPG",
      "/img/white_now/white_Now2.JPG",
      "/img/white_now/white_now_with_soap.JPG",
    ],
    detailedDescription: `Our advanced brightening soap features glutathione and kojic acid to effectively target hyperpigmentation and uneven skin tone. This powerful combination works to inhibit melanin production while promoting a brighter, more luminous complexion with regular use.`,
    usage: `Application Instructions:\n• Use twice daily on face and body\n• Create lather and apply to damp skin\n• Massage gently for 30-60 seconds\n• Rinse thoroughly\n• Follow with sunscreen during daytime use`,
    specifications: {
      keyIngredients:
        "Glutathione, Kojic Acid, Licorice Root Extract, Niacinamide, Pearl Extract",
      volume: "90g / 3.2oz",
      skinType: "All skin types seeking brightening effects",
      soapType: "Advanced Brightening Soap",
      texture: "Fine, dense lather, Pearl-white bar",
      fragrance: "Light, clean scent",
    },
    inStock: true,
    sku: "JMO-FSOAP-003",
    hasColors: false,
    reviews: [],
    likes: 0,
    benefits: [
      "Reduces dark spots and hyperpigmentation",
      "Promotes even skin tone",
      "Brightens and illuminates complexion",
      "Antioxidant protection",
      "Improves skin clarity and radiance",
    ],
    ingredients:
      "Glutathione, Kojic Acid, Glycyrrhiza Glabra (Licorice) Root Extract, Niacinamide (Vitamin B3), Pearl Extract, Sodium Hydroxide, Aqua",
  },
  {
    id: 13,
    slug: "6-in-1-lash-kit-63ef9583",
    name: "Premium Mixed-Density Eyelash Clusters - 6-in-1 Professional Lash Kit",
    displayName: "6-in-1 Lash Kit",
    price: 15,
    isSale: true,
    salePrice: 12,
    category: "lash extensions",
    mainCategories: "lash supplies",
    image: "/img/eye_lashes/Eye_lash.JPG",
    // videoUrl: "/img/eye_lashes/Eye_lash.MP4",
    description:
      "476PCS professional lash clusters in 6 densities (30D-100D) for customizable wispy lash extensions perfect for beginners.",
    weight: 0.08,
    images: ["/img/eye_lashes/Eye_lash.JPG", "/img/eye_lashes/Eyel_lash2.MP4"],
    // videoUrl: "/img/eye_lashes/Eye_lash.MP4",
    detailedDescription: `Experience salon-quality lash extensions from the comfort of your home with our Premium Mixed-Density Eyelash Clusters. This comprehensive 476-piece kit features six different curl densities (30D, 40D, 50D, 60D, 80D, 100D) in beautiful D-curly designs, ranging from natural 10MM to dramatic 16MM lengths. Perfect for both beginners and lash enthusiasts, these professional-grade clusters deliver the perfect wispy, individual lash effect without salon appointments.`,
    usage: `Application Instructions:\n• Apply with professional lash adhesive for optimal hold\n• Start with lighter densities for natural looks\n• Layer heavier clusters for dramatic effects\n• Perfect for creating popular 'wispy lash' trends\n• Can be worn for multiple uses with proper care`,
    specifications: {
      keyIngredients: "High-quality synthetic fibers",
      volume: "476 pieces",
      lashType: "D-curly cluster extensions",
      densityRange: "30D, 40D, 50D, 60D, 80D, 100D",
      lengthRange: "10MM - 16MM",
      texture: "Professional-grade synthetic lashes",
      skillLevel: "Beginner to professional",
    },
    inStock: true,
    sku: "JMO-CLUSTER-001",
    hasColors: false,
    reviews: [],
    likes: 0,
    benefits: [
      "6-density variety for customizable looks",
      "Beginner-friendly cluster application",
      "Salon-quality results at home",
      "Time-saving compared to individual lashes",
      "Cost-effective alternative to salon visits",
      "Lightweight and comfortable all-day wear",
    ],
    ingredients:
      "Premium synthetic fibers, professional lash adhesive compatible",
  },

  {
    id: 15,
    slug: "vitamin-c-ultra-serum-22ab91a6",
    name: "Vitamin C plus Ultra Serum Solution",
    displayName: "Vitamin C Ultra Serum",
    price: 29.99,
    isSale: true,
    salePrice: 20,
    category: "face serum",
    mainCategories: "skincare",
    image: "/img/vitcserum/vitcserum.JPG",
    videoUrl: "/img/vitcserum/vitamin_c_serum.MP4",
    description:
      "Enriched face serum with seven effective ingredients to visibly boost skin's glow and reduce the appearance of pores and fine lines.",
    weight: 0.05,
    images: ["/img/vitcserum/vitcserum.JPG", "/img/vitcserum/vitcserum2.JPG"],
    detailedDescription: `This enriched face serum contains seven effective ingredients to visibly boost skin's glow and reduce the appearance of pores and fine lines. It helps visibly refine skin's texture, moisturize skin, fade dark spots and chloasma for a smooth, glowing appearance.`,
    usage: `How to use:\nDuring the day and night, apply the product on the face, massage gently and pat until absorbed.`,
    specifications: {
      keyIngredients:
        "Glycolic Acid, Glutathione, Centella Asiatica Root Extract, Paeonia Albiflora Root Extract, Hyaluronic Acid, Vitamin C, Niacinamide",
      volume: "50ml / 1.69 fl oz",
      skinType: "All skin types",
      soapType: "Enriched Face Serum",
      texture: "Lightweight serum",
      fragrance: "Unscented",
    },
    inStock: true,
    sku: "JMO-FSERUM-005",
    hasColors: false,
    reviews: [],
    likes: 0,
    benefits: [
      "Visibly boost skin's glow",
      "Reduce the appearance of pores",
      "Reduce fine lines",
      "Refine skin's texture",
      "Moisturize skin",
      "Fade dark spots and chloasma",
      "Smooth, glowing appearance",
    ],
    ingredients:
      "Glycolic Acid, Glutathione, Centella Asiatica Root Extract, Paeonia Albiflora Root Extract, Hyaluronic Acid, Vitamin C, Niacinamide, Ethylhexylglycerin, Piper Methysticum Root Extract, Inositol, Sophora Flavescens Root Extract, Oat Bran Extract, Glyceryl Glucoside, Water, Glycerin",
    warnings: "Keep out of reach of children. Store in a cool, dry place.",
    certified: ["BIO", "Recyclable", "6M shelf life"],
  },

  {
    id: 14,
    slug: "vitamin-c-face-cream-871d689e",
    name: "Vitamin c face cream",
    displayName: false,
    isSale: true,
    salePrice: 25,
    price: 27.99,
    category: "face cream",
    mainCategories: "skincare",
    image: "/img/vitaminc_plus/vitamic_C_plus_Face_cream.JPG",
    videoUrl: "/img/vitaminc_plus/vitamin_c_plus_face_cream.MP4",
    description:
      "Glass-Cream Solution. Moisturizer & Glass Skin & Rejuvenate. Creates glass-textured skin, moisturizes, cleanses, rejuvenates, prevents pigmentation, shrinks pores, and reduces fine lines for boosted radiance.",
    weight: 0.05,
    images: [
      "/img/vitaminc_plus/vitamic_C_plus_Face_cream.JPG",
      "/img/vitaminc_plus/vitamin_C_plus_Face_cream2.JPG",
      "/img/vitaminc_plus/vitamin_C_plus_Face_cream3.JPG",
    ],
    detailedDescription:
      "JMOLUX Vitamin c face cream - Glass-Cream Solution. Moisturizes, rejuvenates, and promotes glass skin. Creates glass-textured skin, adds effective beauty ingredients to moisturize and cleanse, rejuvenates the skin, prevents pigmentation, shrinks pores, reduces fine lines, refines skin's texture, and boosts radiance.",
    usage:
      "How to use:\nDuring the day and night, apply the product on the face, massage gently and pat until absorbed.",
    specifications: {
      keyIngredients:
        "Glycolic Acid, Glutathione, Hyaluronic Acid, Vitamin C, Niacinamide, Centella Asiatica Extract, Paeonia Albiflora Root Extract",
      volume: "50g / 1.76 oz",
      skinType: "All skin types",
      soapType: "Glass-Cream Solution Face Cream",
      texture: "Creamy formula",
      fragrance: "Unscented",
    },
    inStock: true,
    sku: "JMO-FCRM-004",
    hasColors: false,
    reviews: [],
    likes: 0,
    benefits: [
      "Creates glass-textured skin",
      "Moisturizes and cleanses",
      "Rejuvenates the skin",
      "Helps prevent pigmentation",
      "Shrinks pores",
      "Reduces fine lines",
      "Refines skin's texture",
      "Boosts radiance",
    ],
    ingredients:
      "Glycolic Acid, Glutathione, Hyaluronic Acid, Vitamin C, Niacinamide, Centella Asiatica Extract, Paeonia Albiflora Root Extract, Thamniolia Vermicularis Leaf Extract, Shea Butter, Mannan, Sophora Flavescens Root Extract, Piper Methysticum Root Extract, Oat Bran Extract, Ethylhexylglycerin, Sorbitan Isostearate, Water, Glycerin",
    warnings: "Keep out of reach of children. Store in a cool, dry place.",
    certified: ["BIO", "Recyclable", "6M shelf life"],
  },
  {
    id: 17,
    slug: "kojic-turmeric-scrub-cad4bc2f",
    name: "Kojic Acid Turmeric & Lemon Body Scrub",
    displayName: "Kojic Turmeric Scrub",
    price: 12,
    isSale: true,
    salePrice: 10,
    freeGift: true,
    freeGiftMessage: "Free on orders above $50",
    category: "body scrub",
    mainCategories: "skincare",
    image: "/img/lemonKojic/lemonkojic.png",
    description:
      "Exfoliating body scrub with Kojic Acid, Turmeric, and Lemon for brightening, softening, and even skin tone.",
    weight: 0.28,
    images: [
      "/img/lemonKojic/lemonkojic2.png",
      "/img/lemonKojic/lemonkojic1.png",
      "/img/lemonKojic/lemonkojic.png",
    ],
    detailedDescription:
      "Reveal radiant, smooth skin with our Kojic Acid Turmeric & Lemon Body Scrub. This powerful exfoliating blend is crafted to gently buff away dead skin cells while targeting hyperpigmentation and dullness. Kojic Acid and Turmeric work synergistically to brighten and even out skin tone, while Lemon provides a refreshing zest and additional brightening benefits. Your skin will feel incredibly soft, refreshed, and visibly more luminous.",
    usage:
      "Usage Instructions:\n• In the shower or bath, apply a generous amount to damp skin.\n• Gently massage in circular motions, focusing on rough or uneven areas.\n• Rinse thoroughly with warm water.\n• For best results, use 2-3 times per week.\n• Follow with a moisturizer to lock in hydration.",
    specifications: {
      keyIngredients:
        "Kojic Acid, Turmeric Extract, Lemon Peel Oil, Granulated Sugar, Shea Butter",
      volume: "280g / 9.48 oz",
      skinType:
        "All skin types, especially those concerned with dullness, uneven tone, and rough texture.",
      productType: "Exfoliating Body Scrub",
      texture: "Granulated scrub with a rich, creamy base, Yellow-orange color",
      fragrance: "Invigorating citrus and earthy turmeric scent",
    },
    inStock: true,
    sku: "JMO-BSCRUB-001",
    hasColors: false,
    reviews: [],
    likes: 0,
    benefits: [
      "Brightens and evens skin tone",
      "Gently exfoliates dead skin cells",
      "Reduces the appearance of dark spots and hyperpigmentation",
      "Leaves skin feeling soft, smooth, and refreshed",
      "Enhances natural skin radiance",
    ],
    ingredients:
      "Sucrose (Sugar), Glycerin, Aqua, Butyrospermum Parkii (Shea) Butter, Cocos Nucifera (Coconut) Oil, Emulsifying Wax NF, Stearic Acid, Kojic Acid, Curcuma Longa (Turmeric) Root Extract, Citrus Limon (Lemon) Peel Oil, Phenoxyethanol, Caprylyl Glycol, Sorbic Acid, Fragrance (Parfum)",
  },
  {
    id: 16,
    slug: "rapid-bond-lash-adhesive-80e1fcdf",
    name: "Pro-Series Rapid Bond Lash Adhesive",
    displayName: "Rapid Bond Lash Adhesive",
    price: 15,
    isSale: true,
    salePrice: 13,
    category: "eyelash adhesive",
    mainCategories: "lash supplies",
    image: "/img/lashGlue/eyeLashGlue1.png",
    description:
      "Professional-grade eyelash extension glue for rapid 1-2 second bonding and 8-week retention.",
    weight: 0.005,
    images: [
      "/img/lashGlue/eyeLashGlue1.png",
      "/img/lashGlue/eyeLashGlue2.png",
      "/img/lashGlue/eyeLashGlue.png",
      "/img/lashGlue/eyeLashGlue4.png",
    ],
    detailedDescription:
      "Engineered for the master lash artist, our Pro-Series Rapid Bond Adhesive offers a powerful, flexible bond with a near-instant 1-2 second dry time. This thin-viscosity formula ensures a seamless, lightweight finish, reducing clumping and offering clients stunning retention for up to 8 weeks. Its deep black color enhances the lash line for a fuller look.",
    usage:
      "Usage Instructions (Professional Use Only):\n• Shake vigorously for 60 seconds before each use.\n• Dispense one drop onto a jade stone or glue well.\n• Isolate natural lash before dipping extension (1-2mm) into adhesive.\n• Apply extension 0.5-1mm from the lash line. Do not apply to skin.\n• Replace glue drop every 20-30 minutes for best results.\n• Keep nozzle clean and cap tightly secured after use.\n• Store upright in a cool, dark, dry place.",
    specifications: {
      keyIngredients: "Ethyl Cyanoacrylate, PMMA, Carbon Black",
      volume: "5ml / 0.17 fl.oz",
      dryingTime: "1-2 Seconds",
      retention: "Up to 8 Weeks",
      viscosity: "Thin",
      color: "Deep Black",
      optimalHumidity: "45-60%",
      optimalTemperature: "68-75°F (20-24°C)",
    },
    inStock: true,
    sku: "JMO-LGLU-001",
    hasColors: false,
    reviews: [],
    likes: 0,
    benefits: [
      "1-2 second rapid dry time for fast application",
      "Up to 8 weeks of industry-leading retention",
      "Low fume formula for increased client comfort",
      "Thin viscosity for a seamless, non-clumpy bond",
      "Rich black color enhances the lash line",
    ],
    ingredients:
      "Ethyl Cyanoacrylate, Polymethyl Methacrylate (PMMA), Hydroquinone, Carbon Black",
  },

  {
    id: 18,
    slug: "vitamin-c-intensive-serum-7f808914",
    name: "Vitamin C Intensive Serum",
    displayName: false,
    price: 25,
    isSale: true,
    salePrice: 20,
    category: "serum",
    mainCategories: "skincare",
    image: "/img/vitaminC_Intensive/Vitamin_C_Serum1.jpg",
    videoUrl: "",
    description:
      "Intensive brightening serum with Vitamin C, Niacinamide, and Hyaluronic Acid. Fights oxidation, reduces dark spots, and deeply hydrates for smooth, glowing skin.",
    weight: 0.03,
    images: [
      "/img/vitaminC_Intensive/Vitamin_C_Serum1.jpg",
      "/img/vitaminC_Intensive/Vitamin_C_Serum.jpg",
      "/img/vitaminC_Intensive/Vitamin_C_Serum2.jpg",
      "/img/vitaminC_Intensive/Vitamin_C_Serum3.jpg",
    ],
    detailedDescription:
      "JMOLUX Vitamin C Intensive Serum. A potent formula designed to deliver a high concentration of active ingredients. Vitamin C provides antioxidant protection and anti-aging benefits, while Niacinamide works to reduce the appearance of dark spots and melanin. Hyaluronic Acid locks in moisture to hydrate and smooth the skin.",
    usage:
      "How to use:\nAfter cleansing and toning, apply 2-3 drops of serum to the face and neck. Gently massage and pat until fully absorbed. Follow with moisturizer.",
    specifications: {
      keyIngredients: "Vitamin C, Niacinamide, Hyaluronic Acid",
      volume: "30ml / 1.01 oz",
      skinType: "Suitable for all skin types",
      soapType: "Intensive Serum",
      texture: "Lightweight serum",
      fragrance: "Unscented",
    },
    inStock: true,
    sku: "JMO-SER-001",
    hasColors: false,
    reviews: [],
    likes: 0,
    benefits: [
      "Provides antioxidation",
      "Anti-aging benefits",
      "Reduces dark spots",
      "Reduces melanin",
      "Hydrates skin",
      "Locks in moisture",
      "Smooths skin",
    ],
    ingredients:
      "Vitamin C, Niacinamide, Hyaluronic Acid, Water, Glycerin, Butylene Glycol, Xanthan Gum, Phenoxyethanol, Ethylhexylglycerin",
    warnings:
      "For external use only. Keep out of reach of children. Store in a cool, dry place. Avoid contact with eyes.",
    certified: ["Recyclable", "6M shelf life"],
  },
  {
    id: 19,
    slug: "face-mask-cc955ffa",
    name: "Disposable Medical Face Mask",
    displayName: "Face Mask",
    price: 10,
    isSale: true,
    salePrice: 8,
    category: "face mask",
    mainCategories: "medical supplies",
    image: "/img/medical_supplies/face_masks.png", // Using the specified path
    videoUrl: "",
    description:
      "JMOlux Disposable Medical Face Masks provide easy breathability and a secure fit with an adjustable nosepiece and soft ear-loops. Latex-free for comfort and safety.",
    weight: 0.2, // Placeholder weight
    images: [
      "/img/medical_supplies/face_masks.png", // Using the specified path
    ],
    detailedDescription:
      "JMOlux Disposable Medical Face Mask - 50 Pcs/Box. Designed for comfortable and effective protection. Features include easy breathability, an easily adjusted nosepiece for a custom fit, soft and strong round ear-loops for extended wear, and a latex-free composition to prevent skin irritation.",
    usage:
      "How to use:\n1. Place the mask over your nose and mouth with the colored side facing outwards.\n2. Secure the ear-loops around your ears.\n3. Pinch the nosepiece to conform to the shape of your nose.\n4. Pull the bottom of the mask over your chin to ensure full coverage.",
    specifications: {
      keyIngredients: "Non-woven fabric, Melt-blown fabric", // Common mask materials
      volume: "50 PCS/BOX",
      skinType: "All",
      soapType: "Disposable Medical Mask",
      texture: "Soft, breathable fabric",
      fragrance: "None",
    },
    inStock: true,
    sku: "JMO-MASK-001",
    hasColors: false,
    reviews: [],
    likes: 0,
    benefits: [
      "Easy Breath",
      "Easily adjusted Nosepiece",
      "Soft/strong round Ear-loop",
      "Latex-free",
      "50 PCS per box",
    ],
    ingredients: "Non-woven fabric, Melt-blown fabric, Ear-loops, Nose clip", // Common mask materials
    warnings:
      "For single use only. Dispose of after each use. Store in a cool, dry place. Keep out of reach of children.",
    certified: [
      "ASTM F2100-19", // Visible on the box in Image 3
      "CE",
      "ISO", // Visible on the box in Image 1
    ],
  },
  {
    id: 20,
    slug: "nitrile-gloves-ddd8f424",
    name: "Disposable Nitrile Gloves",
    displayName: "Nitrile Gloves",
    price: 10,
    isSale: true,
    salePrice: 8,
    category: "gloves",
    mainCategories: "medical supplies",
    image: "/img/medical_supplies/Disposable_gloves.png",
    videoUrl: "",
    description:
      "JMOlux Disposable Nitrile Gloves are powder-free, textured, and ambidextrous. Non-sterile and food-grade, ideal for various applications. 100 Pcs/Box.",
    weight: 0.5, // Placeholder weight
    images: [
      "/img/medical_supplies/Disposable_gloves.png",
      "/img/medical_supplies/NitrileGloves.png",
    ],
    detailedDescription:
      "JMOlux Disposable Nitrile Gloves offer superior protection and dexterity. These powder-free gloves are textured for enhanced grip, ambidextrous for convenience, and non-sterile for general-purpose use. They are also food-grade certified, making them suitable for handling food. Each box contains 100 pieces.",
    usage:
      "How to use:\n1. Ensure hands are clean and dry.\n2. Carefully slide one hand into a glove, ensuring fingers are fully extended.\n3. Repeat for the other hand.\n4. To remove, grasp the outside of one glove near the cuff and peel it off, turning it inside out. Hold the removed glove in the gloved hand.\n5. Peel off the second glove by putting your fingers inside the cuff of the glove, turning it inside out and over the first glove. Dispose of properly.",
    specifications: {
      keyIngredients: "Nitrile rubber", // Main material
      volume: "100 PCS/BOX",
      skinType: "All",
      soapType: "Disposable Nitrile Gloves",
      texture: "Textured",
      fragrance: "None",
    },
    inStock: true,
    sku: "JMO-GLOVES-001",
    hasColors: false,
    reviews: [],
    likes: 0,
    benefits: [
      "Powder Free",
      "Textured for better grip",
      "Non-sterile",
      "Ambidextrous",
      "Food Grade certified",
      "100 Pcs/Box",
      "CE & ISO certified",
    ],
    ingredients: "Nitrile rubber",
    warnings:
      "For single use only. Dispose of properly after use. Store in a cool, dry place. Avoid extreme temperatures. Keep out of reach of children.",
    certified: ["CE", "ISO", "Food Grade"],
  },
  {
    id: 21,
    slug: "disposable-pads-210a7246",
    name: "Multi-use | Heavy Duty Disposable Pads",
    displayName: "Disposable Pads",
    price: 40,
    isSale: true,
    salePrice: 35,
    category: "disposable pads",
    mainCategories: "medical supplies",
    image: "/img/medical_supplies/dispoasable_sheets.png", // Placeholder as you didn't provide a specific one for pads
    videoUrl: "",
    description:
      'JMOlux Multi-use Heavy Duty Disposable Pads, 36" X 36" with Advanced Leak Proof technology. Ideal for various applications, 50 pads per pack.',
    weight: 2.0, // Placeholder weight for 50 pads
    images: [
      "/img/medical_supplies/dispoasable_sheets.png", // Placeholder as you didn't provide a specific one for pads
    ],
    detailedDescription:
      'JMOlux Multi-use Heavy Duty Disposable Pads are designed for maximum protection and versatility. Each pad measures 36" X 36" and features Advanced Leak Proof technology to ensure superior absorption and containment. This 50-pack is suitable for a wide range of applications, providing reliable care.',
    usage:
      "How to use:\n1. Unfold the pad and place it on the desired surface with the absorbent side facing up.\n2. Ensure the pad lies flat to prevent bunching.\n3. After use, fold the pad inward to contain any liquids and dispose of it properly in a waste receptacle.",
    specifications: {
      keyIngredients:
        "Super absorbent polymer, Non-woven fabric, Waterproof backing", // Common pad materials
      volume: "50 PACK",
      skinType: "N/A", // Not applicable for pads
      soapType: "Disposable Pads",
      texture: "Soft top layer, absorbent core",
      fragrance: "None",
    },
    inStock: true,
    sku: "JMO-PADS-001",
    hasColors: false,
    reviews: [],
    likes: 0,
    benefits: [
      "Multi-use",
      "Heavy Duty",
      '36" X 36" size',
      "50 Pack",
      "Advanced Leak Proof technology",
    ],
    ingredients: "Absorbent polymer, Non-woven fabric, Polyethylene backing",
    warnings:
      "For external use only. Do not flush. Dispose of properly. Keep out of reach of children. Store in a cool, dry place.",
    certified: ["Distributed by JMOlux USA"],
  },
  {
    id: 22,
    slug: "gluta-diamond-series-eba89c00",
    name: "Gluta Diamond Series",
    displayName: false,
    isSale: true,
    salePrice: 180,
    price: 250,
    category: "brightening set",
    mainCategories: "skincare",
    image: "/img/whatsappImages/gluta-double/gluta-double-1.jpeg",
    videoUrl: "",
    description:
      "A luxury brightening skincare set created to hydrate deeply, enhance clarity, and reveal a healthy, radiant glow.",
    weight: 1.2,
    images: ["/img/whatsappImages/gluta-double/gluta-double-1.jpeg"],
    detailedDescription:
      "Gluta Diamond Series is a complete luxury brightening regimen. Each piece in the set is formulated to work together — deeply hydrating the skin, supporting clarity and even tone, and revealing a healthier, more radiant glow with daily use.",
    usage:
      "How to use:\n1. Cleanse and pat skin dry.\n2. Apply each step of the set in the recommended order, morning and night.\n3. Always follow with sunscreen during the day.",
    specifications: {
      keyIngredients: "Glutathione, Vitamin C, Hyaluronic Acid",
      volume: "Full set",
      skinType: "All skin types",
      soapType: "Brightening Skincare Set",
      texture: "Multi-step luxury formulation",
      fragrance: "Light, clean",
    },
    inStock: true,
    sku: "JMO-GLUTA-DIAMOND-001",
    hasColors: false,
    reviews: [],
    likes: 0,
    benefits: [
      "Advanced Brightening",
      "Intense Hydration",
      "Supports clarity and even tone",
      "Healthy, radiant glow",
      "Luxury full-regimen set",
    ],
    ingredients:
      "Glutathione, Vitamin C, Hyaluronic Acid, Niacinamide, Glycerin, plant-based extracts",
    warnings:
      "For external use only. Discontinue use if irritation occurs. Keep out of reach of children. Store in a cool, dry place.",
    certified: ["Distributed by JMOlux USA"],
  },
  {
    id: 23,
    slug: "gluta-carrot-collection-de5e1c07",
    name: "Gluta Carrot Collection",
    displayName: false,
    isSale: true,
    salePrice: 200,
    price: 400,
    category: "brightening set",
    mainCategories: "skincare",
    image: "/img/whatsappImages/gluta-carrot/Glutacarrot1.jpeg",
    videoUrl: "",
    description:
      "Radiant glow in every drop — a brightening body collection with glutathione and carrot extract to nourish, even tone, and reveal a healthier, luminous finish.",
    weight: 1.4,
    images: [
      "/img/whatsappImages/gluta-carrot/Glutacarrot1.jpeg",
      "/img/whatsappImages/gluta-carrot/Glutacarrot2.jpeg",
      "/img/whatsappImages/gluta-carrot/Gluttacarrot3.jpeg",
      "/img/whatsappImages/gluta-carrot/Glutacarrot4.jpeg",
    ],
    detailedDescription:
      "Gluta Carrot Collection is a full body-care routine built around glutathione and carrot extract. The set works together to brighten, deeply hydrate, and even skin tone — shower gel, body oil, body cream and brightening soap, formulated for a head-to-toe radiant glow.",
    usage:
      "How to use:\n1. Start with the brightening soap or shower gel to cleanse.\n2. Apply the body oil to damp skin to lock in moisture.\n3. Follow with the body cream to seal in hydration.\n4. Use consistently morning and night for best results.",
    specifications: {
      keyIngredients: "Glutathione, Carrot Extract, Vitamin C, Vitamin E",
      volume: "Full collection",
      skinType: "All skin types",
      soapType: "Brightening Body Care Set",
      texture: "Multi-product body collection",
      fragrance: "Warm carrot, light citrus",
    },
    inStock: true,
    sku: "JMO-GLUTA-CARROT-001",
    hasColors: false,
    reviews: [],
    likes: 0,
    benefits: [
      "Radiant, even-toned glow",
      "Brightens with glutathione + carrot extract",
      "Deeply hydrates and nourishes",
      "Full head-to-toe body routine",
      "Luxury packaging, gift-ready set",
    ],
    ingredients:
      "Glutathione, Carrot (Daucus Carota) Extract, Vitamin C, Vitamin E, Glycerin, plant-based oils",
    warnings:
      "For external use only. Discontinue use if irritation occurs. Keep out of reach of children. Store in a cool, dry place.",
    certified: ["Distributed by JMOlux USA"],
  },
  // Draft catalog records for homepage galleries. Replace placeholder-marked
  // fields with confirmed packaging or supplier data when it becomes available.
  {
    id: 24,
    slug: "moroccan-black-soap-d697e584",
    isPlaceholder: true,
    name: "Moroccan Whitening Black Soap",
    displayName: "Moroccan Black Soap",
    isSale: true,
    salePrice: 25,
    price: 30,
    category: "body soap",
    mainCategories: "skincare",
    image: "/img/moroccanBlackSoap/moroc.jpeg",
    description:
      "A traditional Moroccan-style black cleansing paste for a deep-cleansing body-care routine.",
    weight: 0.5,
    images: [
      "/img/moroccanBlackSoap/moroc.jpeg",
      "/img/moroccanBlackSoap/moroc2.jpeg",
      "/img/moroccanBlackSoap/moroc3.jpeg",
      "/img/moroccanBlackSoap/moroc4.jpeg",
    ],
    detailedDescription:
      "This rich Moroccan black soap paste is designed to soften surface buildup before exfoliation. Its dense, spreadable texture suits hammam-inspired body-care routines and leaves skin feeling thoroughly cleansed and prepared for moisturizing.",
    usage:
      "Apply a thin layer to wet body skin. Leave on briefly, then massage or exfoliate gently and rinse thoroughly. Avoid the face and eye area until final directions are confirmed.",
    specifications: {
      format: "Traditional black soap paste",
      size: "500g / 16.9oz",
      useArea: "Body",
      routine: "Cleanse before exfoliating",
    },
    inStock: true,
    sku: "DRAFT-MBS-024",
    reviews: [],
    likes: 0,
    benefits: [
      "Prepares skin for exfoliation",
      "Helps lift surface buildup",
      "Rich hammam-style cleansing texture",
      "Leaves skin feeling refreshed",
    ],
    ingredients:
      "Placeholder: confirm the complete ingredient list from the product label.",
  },
  {
    id: 25,
    slug: "molato-brightening-body-oil-651656b6",
    isPlaceholder: true,
    name: "Molato Brightening Body Oil",
    displayName: false,
    price: 35,
    isSale: true,
    salePrice: 30,
    category: "body oil",
    mainCategories: "skincare",
    image: "/img/5Dmolato/moroc5doil.jpeg",
    description:
      "A lightweight brightening body oil blend formulated to moisturize dry skin and support a more even-looking glow.",
    weight: 0.25,
    images: [
      "/img/5Dmolato/moroc5doil.jpeg",
      "/img/5Dmolato/moroc5doil2.jpeg",
      "/img/5Dmolato/moroc5doil3.jpeg",
      "/img/5Dmolato/moroc5doil4.jpeg",
      "/img/5Dmolato/moroc5doil5.jpeg",
      "/img/5Dmolato/moroc5doil6.jpeg",
    ],
    detailedDescription:
      "5D Molato Brightening Body Oil combines emollient plant oils with glutathione, a Vitamin C derivative, alpha-arbutin and botanical extracts. It is intended for daily body hydration, especially on dry areas such as elbows and knees.",
    usage:
      "Apply a few drops to damp or dry body skin after showering. Massage gently until absorbed and use daily. External use only.",
    specifications: {
      texture: "Lightweight body oil",
      useArea: "Body",
      skinType: "Normal to dry skin",
      finish: "Soft, moisturized glow",
    },
    inStock: true,
    sku: "DRAFT-5DMO-025",
    reviews: [],
    likes: 0,
    benefits: [
      "Helps seal in body moisture",
      "Supports a more even-looking tone",
      "Softens dry elbows and knees",
      "Daily-use botanical oil blend",
    ],
    ingredients:
      "Squalane, Caprylic/Capric Triglyceride, Grape Seed Oil, Sunflower Seed Oil, Glutathione, Sodium Ascorbyl Phosphate, Alpha-Arbutin, Licorice Root Extract, Green Tea Extract, Vitamin E, Rosehip Oil, Macadamia Oil, Argan Oil, Rosemary, Tea Tree, Lavender, Lemon and Orange Peel Oils.",
  },
  {
    id: 26,
    slug: "beauty-sun-screen-d90031bd",
    isPlaceholder: true,
    name: "Beauty Sun Screen",
    displayName: false,
    price: 20,
    isSale: true,
    salePrice: 15,
    category: "sunscreen",
    mainCategories: "skincare",
    image: "/img/ss/ss2.jpeg",
    description:
      "A lightweight SPF50+ PA+++ facial sunscreen designed for high sun protection with a non-greasy finish.",
    weight: 0.08,
    images: ["/img/ss/ss2.jpeg", "/img/ss/ss3.jpeg", "/img/ss/ss4.jpeg"],
    detailedDescription:
      "Beauty Sun Screen is a light, thin sunscreen that combines SPF50+ PA+++ UV protection with a comfortable skin feel. The finish is designed to sit smoothly under makeup without feeling heavy.",
    usage:
      "Apply generously to the face and exposed skin as the final morning skincare step. Reapply regularly, especially after sweating, swimming or towel drying.",
    specifications: {
      protection: "SPF50+ PA+++",
      texture: "Lightweight lotion",
      finish: "Non-greasy",
      useArea: "Face and exposed skin",
    },
    inStock: true,
    sku: "DRAFT-OKSPF-026",
    reviews: [],
    likes: 0,
    benefits: [
      "High daily sun protection",
      "Light and thin skin feel",
      "Designed to layer under makeup",
      "Comfortable non-greasy finish",
    ],
    ingredients:
      "Placeholder: confirm active sunscreen filters and full ingredient list.",
  },
  {
    id: 27,
    slug: "whitening-molato-soap-02c611af",
    isPlaceholder: true,
    name: "Whitening Molato Soap",
    displayName: false,
    price: 25,
    isSale: true,
    salePrice: 20,
    category: "body soap",
    mainCategories: "skincare",
    image: "/img/molatoSoap/molato1.jpeg",
    description:
      "An extra-strength Molato cleansing soap in a large-format jar for brightening-focused body-care routines.",
    weight: 0.5,
    images: ["/img/molatoSoap/molato1.jpeg", "/img/molatoSoap/molatoS.jpeg"],
    detailedDescription:
      "Extra Strong 5D Whitening Molato Soap is a concentrated body cleanser presented in a generous 500g jar. It is intended to cleanse thoroughly while supporting a brighter, more even-looking skin appearance.",
    usage:
      "Lather a small amount on wet body skin, massage gently and rinse thoroughly. Begin with limited use and stop if irritation occurs. Avoid the face and eye area until final directions are confirmed.",
    specifications: {
      format: "Jar cleansing soap",
      size: "500g / 16.9oz",
      useArea: "Body",
      strength: "Extra strong",
    },
    inStock: true,
    sku: "DRAFT-MSOAP-027",
    reviews: [],
    likes: 0,
    benefits: [
      "Deep body cleansing",
      "Brightening-focused formula",
      "Large-format jar",
      "Supports an even-looking finish",
    ],
    ingredients:
      "Placeholder: confirm the complete ingredient list from the product label.",
  },
  {
    id: 28,
    slug: "molato-whitening-body-cream-661f5f09",
    isPlaceholder: true,
    isBestSeller: true,
    name: "Molato Whitening Body Cream",
    displayName: false,
    price: 50,
    isSale: true,
    salePrice: 40,
    category: "body cream",
    mainCategories: "skincare",
    image: "/img/molato/molatoC.jpeg",
    description:
      "A rich 500g body cream created for deep hydration and a brighter, more even-looking skin tone.",
    weight: 0.5,
    images: [
      "/img/molato/molatoC.jpeg",
      "/img/molato/molatoC2.jpeg",
      "/img/molato/molatoC3.jpeg",
      "/img/molato/molatoc3in1.jpeg",
      "/img/molato/molatoc4.jpeg",
    ],
    detailedDescription:
      "5D Molato Whitening Body Cream pairs a rich moisturizing texture with a brightening-focused body-care approach. The large jar is suited to daily use across arms, legs and other areas that need lasting hydration.",
    usage:
      "Apply to clean body skin and massage until absorbed. Focus on dry or uneven-looking areas. Use sunscreen on exposed skin during the day.",
    specifications: {
      format: "Rich body cream",
      size: "500g / 16.9oz",
      useArea: "Body",
      focus: "Deep hydration and enhanced-looking tone",
    },
    inStock: true,
    sku: "DRAFT-MCREAM-028",
    reviews: [],
    likes: 0,
    benefits: [
      "Deep daily body hydration",
      "Softens rough, dry areas",
      "Supports a brighter-looking tone",
      "Large-format body-care size",
    ],
    ingredients:
      "Placeholder: confirm the complete ingredient list from the product label.",
  },
  {
    id: 29,
    slug: "gluta-diamond-face-cream-d6bd9c64",
    hidden: true,
    isPlaceholder: true,
    name: "Gluta Diamond Glow Face Cream",
    displayName: "Gluta Diamond Face Cream",
    price: 20,
    category: "face cream",
    mainCategories: "skincare",
    image: "/img/glutaDFaceCream/gd_face1.jpeg",
    description:
      "A premium glutathione face cream developed to moisturize and support a smoother, radiant-looking complexion.",
    weight: 0.05,
    images: ["/img/glutaDFaceCream/gd_face1.jpeg"],
    detailedDescription:
      "Gluta Diamond Glow Face Cream is a 50g daily moisturizer centered on glutathione-powered glow care. Its cream texture is intended to replenish facial moisture while supporting a fresh, even-looking finish.",
    usage:
      "Apply a small amount to cleansed face and neck, then massage gently until absorbed. Use sunscreen during the day.",
    specifications: {
      keyFeature: "Premium glutathione powder",
      size: "50g",
      useArea: "Face and neck",
      texture: "Moisturizing cream",
    },
    inStock: true,
    sku: "DRAFT-GDFC-029",
    reviews: [],
    likes: 0,
    benefits: [
      "Daily facial moisture",
      "Supports a radiant-looking glow",
      "Helps soften dry skin",
      "Compact 50g face-care jar",
    ],
    ingredients:
      "Placeholder: confirm the complete ingredient list from the product carton.",
  },
  {
    id: 30,
    slug: "kojic-face-toner-c5a4725f",
    isPlaceholder: true,
    name: "Kojic Face Toner",
    displayName: false,
    isSale: true,
    salePrice: 15,
    price: 18,
    category: "facial toner",
    mainCategories: "skincare",
    image: "/img/kojic/kk1.jpeg",
    videoUrl: "/img/kojic/kkV.mp4",
    description:
      "A brightening facial toner featuring kojic acid, niacinamide and vitamins C and E for all skin types.",
    weight: 0.15,
    images: [
      "/img/kojic/kk1.jpeg",
      "/img/kojic/kk2.jpeg",
      "/img/kojic/kk3.jpeg",
      "/img/kojic/kk4.jpeg",
    ],
    detailedDescription:
      "Kojic Face Toner combines kojic acid with niacinamide, Vitamin C and Vitamin E in a lightweight post-cleansing step. It is designed to refresh skin and support a clearer, more even-looking complexion.",
    usage:
      "After cleansing, apply to the face with clean hands or a cotton pad, avoiding the eye area. Follow with moisturizer and use sunscreen during the day.",
    specifications: {
      keyIngredients: "Niacinamide, Kojic Acid, Vitamin C, Vitamin E",
      size: "150ml / 5.28 fl oz",
      skinType: "All skin types",
      format: "Pump facial toner",
    },
    inStock: true,
    sku: "DRAFT-KTONER-030",
    reviews: [],
    likes: 0,
    benefits: [
      "Refreshes skin after cleansing",
      "Supports a more even-looking tone",
      "Brightening-focused active blend",
      "Lightweight daily toner step",
    ],
    ingredients:
      "Niacinamide, Kojic Acid, Vitamin C, Vitamin E; confirm the complete formula from the product label.",
  },
  {
    id: 31,
    slug: "luminous-body-oil-f4e2ed22",
    name: "Luminous Body Oil",
    displayName: false,
    hidden: true,
    isSale: true,
    salePrice: 150,
    price: 200,
    category: "body oil",
    mainCategories: "skincare",
    image: "/img/whatsappImages/LuminousBOil/LuminousBOil1.jpeg",
    videoUrl: "/img/whatsappImages/LuminousBOil/LuminousBOilVideo.mp4",
    description:
      "A lightweight glow oil that absorbs fast and leaves skin softly radiant — built to layer under your daily moisturizer.",
    weight: 0.25,
    images: [
      "/img/whatsappImages/LuminousBOil/LuminousBOil1.jpeg",
      "/img/whatsappImages/LuminousBOil/LuminousBOil2.jpeg",
      "/img/whatsappImages/LuminousBOil/LuminousBOil3.jpeg",
      "/img/whatsappImages/LuminousBOil/LuminousBOil5.jpeg",
      "/img/whatsappImages/LuminousBOil/LuminousBOil6.jpeg",
    ],
    detailedDescription:
      "Luminous Body Oil is a lightweight glow oil that absorbs quickly and leaves skin softly radiant. Layer it under your daily moisturizer for an extra luminous finish.",
    usage:
      "Apply a few drops to damp or dry skin after showering. Massage gently until absorbed. Use daily as part of your body care routine.",
    specifications: {
      texture: "Lightweight body oil",
      useArea: "Body",
      skinType: "All skin types",
      finish: "Soft, radiant glow",
    },
    inStock: true,
    sku: "JMO-LUMINOUS-BO-031",
    reviews: [],
    likes: 0,
    benefits: [
      "Lightweight, fast-absorbing formula",
      "Leaves skin softly radiant",
      "Layers under daily moisturizer",
      "Daily-use body glow oil",
    ],
    ingredients: "Confirm the complete ingredient list from the product label.",
  },
  {
    id: 32,
    slug: "luminous-body-oil-set-8a31c40e",
    name: "Luminous Body Oil Set",
    displayName: false,
    isSale: true,
    salePrice: 180,
    price: 292,
    category: "Body Care Set",
    mainCategories: "skincare",
    image: "/img/luminous_set/luminous_set_collage.jpg",
    description:
      "A 4-piece glow set bundling Luminous Body Milk & Body Oil, Bee Honey Soap, Vitamin C Intensive Serum, and Kojic Acid Turmeric & Lemon Body Scrub.",
    weight: 0.68,
    images: [
      "/img/luminous_set/luminous_set_collage.jpg",
      "/img/whatsappImages/LuminousBOil/LuminousBOil1.jpeg",
      "/img/bee_honey_soap/all_natural_bee_honey_2.JPG",
      "/img/vitaminC_Intensive/Vitamin_C_Serum1.jpg",
      "/img/lemonKojic/lemonkojic1.png",
    ],
    detailedDescription: `The Luminous Body Oil Set brings together four JMOLUX favorites for a complete head-to-toe glow routine. The set includes the Luminous Beauty Body Milk & Body Oil duo for fast-absorbing radiance, the All Natural Bee Honey Soap for deep moisturizing cleanse, the Vitamin C Intensive Serum for brightening and anti-aging, and the Kojic Acid Turmeric & Lemon Body Scrub to gently exfoliate and even skin tone.`,
    usage: `Start with the Kojic Acid Turmeric & Lemon Body Scrub 2-3 times per week to exfoliate. Cleanse daily with the Bee Honey Soap. Apply the Vitamin C Intensive Serum to face and neck after cleansing. Finish with the Luminous Body Milk & Body Oil on damp skin for a soft, radiant glow.`,
    specifications: {
      setIncludes:
        "Luminous Beauty Body Milk & Body Oil (500ml + 300ml), All Natural Bee Honey Soap (120g), Vitamin C Intensive Serum (30ml), Kojic Acid Turmeric & Lemon Body Scrub (280g)",
      keyIngredients: "Vitamin C, Raw Bee Honey, Kojic Acid, Turmeric",
      skinBenefits: "Brightening, Hydrating, Exfoliating, Antioxidant protection",
      skinType: "All skin types",
      packaging: "Gift-ready bundle",
    },
    inStock: true,
    sku: "SET-LUM-032",
    hasColors: false,
    reviews: [],
    likes: 0,
    benefits: [
      "Complete 4-step glow routine in one bundle",
      "Saves money compared to buying each item separately",
      "Perfect for gifting",
      "Brightens, hydrates, and exfoliates",
    ],
    ingredients:
      "See individual product listings for full ingredient lists.",
  },
];

export const mainCategories = [
  "skincare",
  "haircare",
  "scrub set",
  "medical supplies",
  "accessories",
];
